import React, { useState, useEffect } from "react";
import { Container, Row, Col, Image, Form } from "react-bootstrap";
import { FaEdit, FaSave } from "react-icons/fa";
import aboutImageDefault from "../Profile/profileimage/shoert.jpg";

const Cateringaboutus = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [aboutText, setAboutText] = useState({ aboutUs: "" });
    const [previewImage, setPreviewImage] = useState(aboutImageDefault);
    const [imageFile, setImageFile] = useState(null);
    const [vendorId, setVendorId] = useState(null);
    const [aboutUsId, setAboutUsId] = useState(null);

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    useEffect(() => {
        if (vendorId) fetchAboutUsData(vendorId);
    }, [vendorId]);

    const fetchAboutUsData = async (vendorId) => {
        const token = localStorage.getItem("authToken");
        if (!token || !vendorId) return;

        try {
            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/aboutus/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.ok) {
                const data = await response.json();
                setAboutText({ aboutUs: data.aboutUs || "" });
                setAboutUsId(data.aboutUsId || null);

                // If image URL exists, use it for preview
                if (data.image) {
                    setPreviewImage(data.image);
                } else {
                    setPreviewImage(aboutImageDefault);
                }
            }
        } catch (err) {
            console.error("Error fetching About Us:", err);
        }
    };

    const handleTextChange = (e) => setAboutText({ ...aboutText, aboutUs: e.target.value });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImageFile(file);

        const reader = new FileReader();
        reader.onloadend = () => setPreviewImage(reader.result);
        reader.readAsDataURL(file);
    };

    const sendFormData = async (url, method) => {
        const token = localStorage.getItem("authToken");
        if (!vendorId || !token) return alert("Vendor ID or auth token missing");

        if (!aboutText.aboutUs.trim()) return alert("Please enter About Us text");

        const formData = new FormData();
        formData.append(
            "aboutUsData",
            new Blob([JSON.stringify({ aboutUs: aboutText.aboutUs })], { type: "application/json" })
        );

        if (imageFile) {
            formData.append("image", imageFile);
        }

        try {
            const response = await fetch(url, {
                method,
                headers: { Authorization: `Bearer ${token}` }, // Do NOT set Content-Type
                body: formData,
            });

            if (response.ok) {
                alert(method === "POST" ? "Added successfully!" : "Updated successfully!");
                fetchAboutUsData(vendorId);
            } else {
                const err = await response.json();
                alert(`Failed: ${err.message || "Unknown error"}`);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("Something went wrong. Please try again.");
        }
    };

    const handleAddAboutUs = async () => {
        const url = `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/aboutus/add/${vendorId}`;
        await sendFormData(url, "POST");
    };

    const handleEditSaveToggle = async () => {
        if (isEditing && aboutUsId) {
            const url = `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/aboutus/update/${aboutUsId}`;
            await sendFormData(url, "PUT");
        }
        setIsEditing((prev) => !prev);
    };

    return (
        <Container fluid className="py-4">
            <Row style={{ border: "1px solid #bbb", borderRadius: "5px" }} className="align-items-center">
                <div className="d-flex justify-content-center w-100 px-4 pt-3">
                    <h1 style={{ color: "#b15dc6", fontWeight: "bold", textAlign: "center", marginBottom: "10px" }}>
                        ABOUT US
                    </h1>

                    <button onClick={handleAddAboutUs} style={buttonStyle}>Add+</button>
                    <button onClick={handleEditSaveToggle} style={buttonStyle}>
                        {isEditing ? <FaSave /> : <FaEdit />}
                    </button>
                </div>

                <Col md={6} className="p-4">
                    <Form.Control
                        as="textarea"
                        rows={10}
                        value={aboutText.aboutUs}
                        onChange={handleTextChange}
                        readOnly={!isEditing}
                        placeholder="Write about us..."
                        style={styles.text}
                    />
                </Col>

                <Col md={6} className="text-center p-4">
                    <div className="position-relative d-inline-block">
                        {isEditing && (
                            <input
                                type="file"
                                accept="image/*"
                                id="imageUpload"
                                style={{ display: "none" }}
                                onChange={handleImageChange}
                            />
                        )}
                        <label htmlFor={isEditing ? "imageUpload" : ""} style={{ cursor: isEditing ? "pointer" : "default" }}>
                            <Image src={previewImage} alt="About Maamaa's Restaurant" fluid rounded style={styles.image} />
                        </label>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

const buttonStyle = {
    height: "35px",
    borderRadius: "5px",
    border: "none",
    background: "#b15cd6",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    width: "80px",
    marginLeft: "20px",
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
};

const styles = {
    image: {
        width: "100%",
        objectFit: "cover",
        borderRadius: "12px",
        height: "310px",
        maxHeight: "350px",
        marginTop: "-20px",
        boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
    },
    text: {
        fontSize: "16px",
        color: "#333",
        lineHeight: "1.8",
        textAlign: "justify",
        border: "none",
        fontFamily: "math",
        resize: "none",
        outline: "none",
    },
};

export default Cateringaboutus;
